import 'css-chunksrc/client/pages/planzoneParametersPage/organization/sheet/styles.scss';export default {
  "organization": "_organization_1vtcd_1",
  "row": "_row_1vtcd_5",
  "group": "_group_1vtcd_17",
  "title": "_title_1vtcd_25",
  "text": "_text_1vtcd_31"
};